import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import { whitelistStyles } from "../../core/hoc"; //  our custom components

import Label from "../../core/label";
import { sizes, statuses } from "../../../enums";
var StatusLabel = createComponent({
  displayName: 'StatusLabel',
  propTypes: {
    text: PropTypes.string,
    status: PropTypes.oneOf(statuses.ALL).isRequired,
    size: PropTypes.oneOf(sizes.ALL)
  },
  defaultProps: {
    text: undefined,
    size: sizes.X4
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _cx2, _cx3;

    var _cx = cx((_cx2 = {
      ck: true,
      'status-label': true
    }, _cx2["status-label--" + props.size] = props.size, _cx2["status-label--" + props.status] = props.status, _cx2));

    var _led = cx((_cx3 = {
      'status-label__status-led': true
    }, _cx3["status-label__status-led--" + props.status] = props.status, _cx3));

    return /*#__PURE__*/React.createElement("div", {
      className: _cx,
      style: props.style
    }, /*#__PURE__*/React.createElement("div", {
      className: _led
    }), props.text ? /*#__PURE__*/React.createElement(Label, {
      size: props.size,
      text: props.text
    }) : null);
  }
});
export default whitelistStyles()(StatusLabel);
//# sourceMappingURL=index.js.map